<script>
import Button from '@/components/Button';
import MainCard from '@/components/MainCard';

export default {
  name: 'Header',
  components: { Button, MainCard },
};
</script>

<template>
  <v-row class="launchpad__header">
    <v-col>
      <div class="text-center mb-10">
        <h1 class="launchpad__title">{{ $t('launchpad.title') }}</h1>
        <h4 class="launchpad__subline">{{ $t('launchpad.subline') }}</h4>
      </div>
      <v-row>
        <v-col cols="8" offset-md="2">
          <v-row justify="space-around">
            <v-col cols="auto">
              <Button :to="{ name: 'stakeselect' }" class="nft-link"  auth-only>
                {{ $t('launchpad.btn-stake') }}
              </Button>
            </v-col>
            <v-col cols="auto" auth-only>
              <Button href="https://docs.spaceswap.app/spaceswap/products/spaceswap-starter/bsc-guide">
                {{ $t('launchpad.btn-guide') }}
              </Button>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="space-around" class="mt-10">
        <v-col cols="12" md="6">
          <MainCard class="index-page-card--ido">
            <template #card-title>
              {{ $t('launchpad.ido.title') }}
            </template>
            <template #card-info>{{ $t('launchpad.ido.description') }}</template>
            <template #card-button>
              <Button
                class="avalanche-btn-blue"
                href="https://docs.google.com/forms/d/e/1FAIpQLSdBvqMttQMw0usK1vACiqX1dVbYeSWsH13_6vMiMCrP89hrXg/viewform"
              >
                {{ $t('launchpad.btn-apply') }}
              </Button>
            </template>
          </MainCard>
        </v-col>
        <v-col cols="12" md="6">
          <MainCard class="index-page-card--calendar">
            <template #card-title>
              {{ $t('launchpad.calendar.title') }}
            </template>
            <template #card-info>{{ $t('launchpad.calendar.description') }}</template>
            <template #card-button>
              <Button  auth-only :to="{ name: 'calendar' }">
                {{ $t('launchpad.btn-calendar') }}
              </Button>
            </template>
          </MainCard>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style lang="scss">
.launchpad {
  &__header {
    @media screen and (max-width: $breakpoint-sm) {
      display: none;
    }

    .btn {
      min-width: 23rem;

      @media screen and (max-width: $breakpoint-md) {
        min-width: 38rem;
      }
    }
  }
}
</style>
